import cancelComponent from './index.vue'

let instance = null

export default {
  install (Vue, options) {
    const Constructor = Vue.extend(cancelComponent)
    if (!instance) {
      instance = new Constructor()
      instance.$mount(document.createElement('div'))
      document.body.appendChild(instance.$el)
    }
    Vue.prototype.$showCouponList = () => {
      instance.show()
    }
  }
}
